import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-80c0c556")

_pushScopeId("data-v-80c0c556")
const _hoisted_1 = { class: "w-full flex flex-col gap-y-4 city-exclude-radio" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", {
  for: "city1",
  class: "cursor-pointer"
}, "No City", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  for: "city2",
  class: "cursor-pointer"
}, "Custom City", -1)
const _hoisted_4 = {
  key: 0,
  class: "w-full flex flex-col gap-y-4 pl-8"
}
const _hoisted_5 = { class: "w-full flex flex-col gap-y-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Kota FTZ "),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-500" }, "(Opsional)")
], -1)
const _hoisted_7 = {
  key: 0,
  style: {"padding-top":"11px","padding-bottom":"11px"},
  class: "w-full border border-gray-lp-400 cursor-not-allowed bg-white rounded-md leading-tight px-3 text-12px xxl:text-14px pr-8 font-normal focus:outline-none text-gray-lp-600",
  value: "-",
  disabled: true
}
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Kota Non-FTZ "),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-500" }, "(Opsional)")
], -1)
const _hoisted_9 = {
  key: 2,
  style: {"padding-top":"11px","padding-bottom":"11px"},
  class: "w-full border border-gray-lp-400 cursor-not-allowed bg-white rounded-md leading-tight px-3 text-12px xxl:text-14px pr-8 font-normal focus:outline-none text-gray-lp-600",
  value: "-",
  disabled: true
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_custom_dropdown = _resolveComponent("custom-dropdown")!
  const _component_multiple_select_search = _resolveComponent("multiple-select-search")!

  return (_openBlock(), _createBlock(_component_custom_dropdown, {
    placeholder: _ctx.placeholder,
    value: _ctx.selectedValueName,
    isDisabled: false,
    isExpand: _ctx.cityExcludeOpened,
    "onUpdate:isExpand": _cache[14] || (_cache[14] = ($event: any) => (_ctx.cityExcludeOpened = $event))
  }, {
    default: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.watchModelValue) + " ", 1),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", {
          class: "p-field-radiobutton gap-x-3 flex flex-row",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, [
          _createVNode(_component_RadioButton, {
            id: "city1",
            name: "city-exclude",
            value: "No City",
            modelValue: _ctx.radioValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.radioValue = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_2
        ]),
        _createVNode("div", {
          class: "p-field-radiobutton gap-x-3 flex flex-row",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, [
          _createVNode(_component_RadioButton, {
            id: "city2",
            name: "city-exclude",
            value: "Custom City",
            modelValue: _ctx.radioValue,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.radioValue = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_3
        ]),
        (_ctx.radioValue === 'Custom City')
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_custom_dropdown, {
                placeholder: "Pilih custom city",
                value: _ctx.selectedCustomCity.name,
                isExpand: _ctx.customCityOpened,
                "onUpdate:isExpand": _cache[5] || (_cache[5] = ($event: any) => (_ctx.customCityOpened = $event))
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_5, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customCityOptions, (option, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: `${index}`,
                        class: ["cursor-pointer hover:text-red-lp-100", 
                _ctx.selectedCustomCity.code.toLowerCase() ===
                option.code.toLowerCase()
                  ? 'text-red-lp-100'
                  : ''
              ],
                        onClick: () => _ctx.onSelectCustomCity(option)
                      }, _toDisplayString(option.name), 11, ["onClick"]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["value", "isExpand"]),
              _hoisted_6,
              (_ctx.selectedCustomCity.code.toLowerCase() === 'non_ftz')
                ? (_openBlock(), _createBlock("input", _hoisted_7))
                : (_openBlock(), _createBlock(_component_multiple_select_search, {
                    onFocus: _cache[6] || (_cache[6] = () => _ctx.onFocusCity('', 'yes')),
                    onFilter: _cache[7] || (_cache[7] = e => _ctx.fetchCity(e, 'yes')),
                    options: _ctx.cityList,
                    modelValue: _ctx.selectedFtz,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedFtz = $event)),
                    keyName: "name",
                    keyValue: "code",
                    placeholder: "Cari kota",
                    isLoading: _ctx.isLoadingCity,
                    showSelected: false,
                    showReset: "",
                    showSelectedInInput: "",
                    key: _ctx.cityExcludeOpened,
                    onChange: _ctx.onChange,
                    onReset: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onReset('yes')))
                  }, null, 8, ["options", "modelValue", "isLoading", "onChange"])),
              _hoisted_8,
              (_ctx.selectedCustomCity.code.toLowerCase() === 'ftz')
                ? (_openBlock(), _createBlock("input", _hoisted_9))
                : (_openBlock(), _createBlock(_component_multiple_select_search, {
                    onFocus: _cache[10] || (_cache[10] = () => _ctx.onFocusCity('', 'no')),
                    onFilter: _cache[11] || (_cache[11] = e => _ctx.fetchCity(e, 'no')),
                    options: _ctx.cityList,
                    modelValue: _ctx.selectedNonFtz,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedNonFtz = $event)),
                    keyName: "name",
                    keyValue: "code",
                    placeholder: "Cari kota",
                    isLoading: _ctx.isLoadingCity,
                    showSelected: false,
                    showReset: "",
                    showSelectedInInput: "",
                    key: _ctx.cityExcludeOpened,
                    onChange: _ctx.onChange,
                    onReset: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onReset('no')))
                  }, null, 8, ["options", "modelValue", "isLoading", "onChange"]))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["placeholder", "value", "isExpand"]))
})